import * as React from "react"
import { Helmet } from "react-helmet"

const SocialStructuredData = () => {
	const contact = {
		"@context": "http://schema.org",
		"@type": "Organization",
		url: `${process.env.RAZZLE_BASE_URL}`,
		logo: `${process.env.RAZZLE_BASE_URL}/logo.png`,
		contactPoint: [
			{
				"@type": "ContactPoint",
				telephone: "+982188932446",
				contactType: "customer support",
				areaServed: "IR",
				availableLanguage: ["Persian", "English"],
			},
			{
				"@type": "ContactPoint",
				telephone: "+98218832447",
				contactType: "sales",
				areaServed: "IR",
				availableLanguage: ["Persian", "English"],
				sameAs: [
					"https://twitter.com/antivirus_ir",
					"https://instagram.com/antivirus.ir",
					"https://telegram.me/antivirusir",
					"https://www.aparat.com/antivirus_ir",
				],
			},
		],
	}

	const phone = {
		"@context": "http://schema.org",
		"@type": "WebSite",
		url: `${process.env.RAZZLE_BASE_URL}`,
		potentialAction: {
			"@type": "SearchAction",
			target: `${process.env.RAZZLE_BASE_URL}/search/{search_term_string}`,
			"query-input": "required name=search_term_string",
		},
	}

	return (
		<Helmet>
			<script type="application/ld+json">
				{`${JSON.stringify(contact)}`}
			</script>
			<script type="application/ld+json">
				{`${JSON.stringify(phone)}`}
			</script>
		</Helmet>
	)
}

export default SocialStructuredData
